module.exports = {
	"id": "HR",
	"name": "Croatia",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.02019,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": 0.00673,
			"19": null,
			"20": null,
			"21": null,
			"22": 0.08749,
			"23": null,
			"24": null,
			"25": null,
			"26": 0.06057,
			"27": null,
			"28": null,
			"29": 0.00673,
			"30": 0.00673,
			"31": 0.04711,
			"32": 0.00673,
			"33": 0.03365,
			"34": 0.11441,
			"35": 0.02692,
			"36": 0.02019,
			"37": 0.04038,
			"38": 0.06057,
			"39": 0.07403,
			"40": 0.04038,
			"41": 0.02019,
			"42": 0.02019,
			"43": 0.15479,
			"44": 0.08076,
			"45": 0.05384,
			"46": 0.06057,
			"47": 0.12114,
			"48": 0.08749,
			"49": 2.47664,
			"50": 0.12114,
			"51": 0.39707,
			"52": 0.39034,
			"53": 29.83409,
			"54": 7.83372,
			"55": 0.07403,
			"56": 0.02692,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.00673,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": 0.01346,
			"13": null,
			"14": null,
			"15": null,
			"16": 0.01346,
			"17": null,
			"18": 0.01346,
			"19": null,
			"20": 0.01346,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": 0.02019,
			"27": null,
			"28": 0.02019,
			"29": null,
			"30": 0.00673,
			"31": 0.01346,
			"32": 0.00673,
			"33": 0.01346,
			"34": 0.02019,
			"35": 0.02019,
			"36": 0.01346,
			"37": 0.02019,
			"38": 0.0673,
			"39": 0.0673,
			"40": 0.04038,
			"41": 0.06057,
			"42": 0.04711,
			"43": 0.14133,
			"44": 0.06057,
			"45": 0.12787,
			"46": 0.08076,
			"47": 0.63262,
			"48": 0.53167,
			"49": 11.27275,
			"50": 0.09422,
			"51": null,
			"52": null,
			"3.5": null,
			"3.6": 0.01346
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": 0.03365,
			"29": null,
			"30": 0.00673,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": 0.00673,
			"36": 0.07403,
			"37": 0.04038,
			"38": 0.03365,
			"39": 0.02019,
			"40": 1.04315,
			"41": 0.18844,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.10768
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": 0.02019,
			"6": null,
			"7": 0.01346,
			"8": 0.06057,
			"9": 0.06057,
			"10": 0.44418,
			"3.1": null,
			"3.2": null,
			"5.1": 0.04038,
			"6.1": 0.02019,
			"7.1": null,
			"9.1": 0.27593
		},
		"ios_saf": {
			"8": 0,
			"10": 3.75540849292,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.101203913405,
			"8.1-8.4": 0.186969941715,
			"9.0-9.2": 0.0891966694421,
			"9.3": 1.36082098251
		},
		"android": {
			"3": 0,
			"4": 0.0429409302326,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00536761627907,
			"4.1": 0.154894069767,
			"4.2-4.3": 0.387235174419,
			"4.4": 0.887957093023,
			"4.4.3-4.4.4": 0.895625116279
		},
		"ie": {
			"6": null,
			"7": 0.00673,
			"8": 0.18171,
			"9": 0.15479,
			"10": 0.16152,
			"11": 3.60728,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0259334027402,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.000720372298338
		},
		"edge": {
			"12": 0.08076,
			"13": 0.43072,
			"14": 1.0095
		},
		"ie_mob": {
			"10": 0.206332394366,
			"11": 0.840067605634
		},
		"bb": {
			"7": 0.00654,
			"10": null
		},
		"samsung": {
			"0": 3.0084
		},
		"and_uc": {
			"0": 0.0654
		},
		"op_mini": {
			"0": 0.349396224961
		},
		"and_chr": {
			"0": 21.76524
		},
		"and_ff": {
			"0": 0.01962
		}
	},
	"total": 98.13738
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/HR.json
 ** module id = 544
 ** module chunks = 0
 **/